import { render, staticRenderFns } from "./DadosConcessao.vue?vue&type=template&id=7fd8c482&scoped=true&"
import script from "./DadosConcessao.vue?vue&type=script&lang=js&"
export * from "./DadosConcessao.vue?vue&type=script&lang=js&"
import style0 from "./DadosConcessao.vue?vue&type=style&index=0&id=7fd8c482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd8c482",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VProgressCircular,VRow,VSimpleTable})
